// import { useParams } from "react-router-dom";
// import { useState } from "react";

// const AddScriptForm = () => {
//   const { paper_id } = useParams();

//   const [formData, setFormData] = useState({
//     id: paper_id,
//     name: "",
//     description: ""
//   });

//   console.log("Id is... "+ paper_id)

//   return (
//     <form>
//       <div>
//         <label>ID</label>
//         <input
//           type="text"
//           value={formData.id}
//           readOnly 
//         />
//       </div>

//       <div>
//         <label>Name</label>
//         <input
//           type="text"
//           value={formData.name}
//           onChange={(e) =>
//             setFormData({ ...formData, name: e.target.value })
//           }
//         />
//       </div>

//       <div>
//         <label>Description</label>
//         <input
//           type="text"
//           value={formData.description}
//           onChange={(e) =>
//             setFormData({ ...formData, description: e.target.value })
//           }
//         />
//       </div>

//       <button type="submit">Submit</button>
//     </form>
//   );
// };


import {useState} from "react";
import { useParams } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import {toast} from 'react-hot-toast';
import { useNavigate } from "react-router-dom";

export default function AddScriptForm(){
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [errors, setErrors] = useState({});
    // const [newPaper, setNewPaper] = useState({
    //     name:'',
    //     subject:'',
	// 	    school:'',
    //     paper_year:'',
    //     grade_category:'',
    //     grade_level:'',
    //     paper : '',
    // })

    const { paper_id } = useParams();

    const [newPaper, setNewPaper] = useState({
      id: paper_id,
      name: "",
      script : ""
    });

    console.log("Id is... "+ paper_id)
    
    // const [selectedFile, setSelectedFile] = useState(null)

    const handleChange = (e)=>{
        setNewPaper({...newPaper, [e.target.name]: e.target.value})
    }

    const handleFileChange = (e)=>{
        //setNewPaper({...newPaper, paper: e.target.files[0]})
        const file = e.target.files[0];
        if(file){
            setNewPaper({...newPaper, script : file})
        } 
    }

    const handleSubmit = async (event)=>{
        const formData = new FormData()
        formData.append("paper_id", newPaper.id)
        formData.append("name", newPaper.script)
        
        event.preventDefault();
        let isValid = true;
        const newErrors = {};

        if(!newPaper.id){
            newErrors.id = 'Id is required';
            isValid = false;
        }
        if(!newPaper.script){
            newErrors.name = 'No File Selected';
            isValid = false;
        }

        setErrors(newErrors);

        if(isValid){
            setUploadStatus('uploading');       

            const user = JSON.parse(localStorage.getItem("user"));

            console.log(user.accessToken);

            try {
                const response = await axios.post('https://coda.easylinksmw.com/api/script/add', formData, {
                    headers : {
                        authorization : "Bearer " + user.accessToken
                    },
                    onUploadProgress : (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploadProgress(percentCompleted);
                },           
            });
            setUploadStatus('success');
            console.log('Response: ', response.data);
            toast.success('Paper uploaded succcessfully')
            //navigate('/papers');
            //window.location.reload();

            setNewPaper({
                id:'',
                name : '',
                script :''            
            });

            } catch (error) {
                // The request was made and the server responded with a status code
                setUploadStatus('failed');
                console.error('Upload error:', error);
                //console.error('Status code:', error.response.status);
                toast.error('Paper uploaded Failed. Try again')
                navigate('/create');            
            } 
        }        
    }
    
    return(
        <div style={{marginTop: 20}}>
            <div className="row">
                <div className="col-md-6 offset-md-3">
                <h3 className="text-center ">Upload Marking Script </h3>
                <Form encType ="multipart/form-data" method="post">
                    {/* <Form.Group className="mb-3" controlId="paper_name">
                        <Form.Label>Paper Name</Form.Label>
                        <Form.Control onChange={handleChange} name="paper_name" value={newPaper.paper_name}  type="text" placeholder="paper name" />
                    </Form.Group> */}
					<Form.Group className="mb-3" controlId="paper_subject">
                        <Form.Label>Paper Id</Form.Label>
                        <Form.Control name="id" value={newPaper.id} readOnly  type="text" />
                        {errors.id && <p className="error">{errors.id}</p>}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="last_name">
                        <Form.Label>Select File (PDF files only)</Form.Label>
                        <Form.Control name="script" type="file" onChange={handleFileChange} required/>
                        {errors.name && <p className="error">{errors.name}</p>}
                    </Form.Group>
                    <Button
                        style={{width:'100%', marginTop:'1rem'}} 
                        onClick={handleSubmit} 
                        variant="primary">
                        {uploadStatus === 'uploading' ? 'Uploading...' : 'Submit'}
                    </Button>
                </Form>
                {uploadStatus === 'uploading' && (
                    <div className="progress-container">
                    <progress value={uploadProgress} max="100" />
                    <span>{uploadProgress}%</span>
                    </div>
                )}
                {uploadStatus === 'success' && (
                    <div className="success-message">
                    File uploaded successfully!
                    </div>
                )}
                </div>
            </div>           
        </div>
    )
}